import * as actions from '../actions/speechToTextActions';

const initialState = {
	hasTranscription: '',
	transcriptionData: '',
	showPreview: false,
	rawTranscribedText: 'no transcription available',
	appMode: 'edit',
	editingTab: 'subtitle',
	isMountedSubtitleUpdated: false,
	subtitleIsUpdating: false,
};

export const speechToTextReducer = (state = initialState, action) => {
	switch (action.type) {
		case actions.RESET_SPEECH_TO_TEXT_REDUCER:
			return {
				...state,
				hasTranscription: '',
				transcriptionData: '',
			};
		case actions.TOGGLE_SHOW_PREVIEW:
			return {
				...state,
				showPreview: action.showPreview,
			};
		case actions.SET_RAW_TRANSCRIPTION_TEXT:
			return {
				...state,
				rawTranscribedText: action.rawTranscribedText,
			};
		case actions.SET_APP_MODE:
			return {
				...state,
				appMode: action.mode,
			};
		case actions.SET_EDITING_TAB:
			return {
				...state,
				editingTab: action.editingTab,
			};
		case actions.SET_IS_MOUNTED_SUB_UPDATED:
			return {
				...state,
				isMountedSubtitleUpdated: action.mountedSubUpdate,
			};
		case actions.SET_SUBTITLE_IS_UPDATING:
			return {
				...state,
				subtitleIsUpdating: action.subtitleIsUpdating,
			};
		case actions.TRANSCRIPTION_LOAD_REQUEST_FAILURE:
			return {
				...state,
				hasTranscription: action.error,
			};
		case actions.TRANSCRIPTION_LOAD_REQUEST_SUCCESS:
			return {
				...state,
				transcriptionData: action.data,
			};
		default:
			return state;
	}
};
